import React from 'react';
import PropTypes from 'prop-types';
import Search from './Search';
import style from './SearchableTable.scss';
import { Table, checkboxValidation } from '.';

export default class SearchableTable extends React.Component {
  static propTypes = {
    columns: PropTypes.array.isRequired,
    source: PropTypes.array.isRequired,
    enableCheckboxes: PropTypes.bool,
    onCheckChange: checkboxValidation,
    checkedIds: PropTypes.array,
    filters: PropTypes.array,
    rowAuth: PropTypes.func,
    rowAuthMsg: PropTypes.string,
    onlyShowAuthenticated: PropTypes.bool,
    toggleAuthenticatedPages: PropTypes.func,
    search: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired,
    noResultsComponent: PropTypes.node,
    selectedFilters: PropTypes.object.isRequired,
    rightOfSearch: PropTypes.arrayOf(PropTypes.func),
    leftOfSearch: PropTypes.arrayOf(PropTypes.func),
    rightOfTable: PropTypes.node,
    searchStyle: PropTypes.string,
    builderListViewFeature: PropTypes.bool,
    clearFilters: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      disabledRowCount: 0,
      disabledRowIds: [],
    };
  }

  static getDerivedStateFromProps = (props) => {
    const { source, rowAuth } = props;
    if (!rowAuth) return null;

    const disabledRowIds = source.reduce((disabled, item) => {
      if (!rowAuth(item)) disabled.push(item.id);
      return disabled;
    }, []);

    return { disabledRowCount: disabledRowIds.length, disabledRowIds };
  }

  render = () => {
    const {
      columns,
      source,
      enableCheckboxes,
      onCheckChange,
      checkedIds,
      filters,
      rowAuth,
      rowAuthMsg,
      onlyShowAuthenticated,
      toggleAuthenticatedPages,
      rightOfSearch,
      leftOfSearch,
      rightOfTable,
      searchStyle,
      builderListViewFeature,
      search,
      updateFilters,
      selectedFilters,
      clearFilters,
      noResultsComponent,
    } = this.props;

    const noResults = source.length === 0;

    return (
      <div className={builderListViewFeature ? style.tableContainer : style.noSearch}>
        <div className={`${searchStyle} ${builderListViewFeature ? style.searchArea : undefined}`}>
          <Search
            filters={filters}
            onlyShowAuthenticated={onlyShowAuthenticated}
            toggleAuthenticatedPages={toggleAuthenticatedPages}
            rowAuth={rowAuth}
            rightOfSearch={rightOfSearch}
            leftOfSearch={leftOfSearch}
            disabledRowCount={this.state.disabledRowCount}
            builderListViewFeature={builderListViewFeature}
            search={search}
            updateFilters={updateFilters}
            selectedFilters={selectedFilters}
            clearFilters={clearFilters}
          />
        </div>
        {noResults && noResultsComponent ? (
          noResultsComponent
        ) : (
          <Table
            columns={columns}
            source={source}
            enableCheckboxes={enableCheckboxes}
            onCheckChange={onCheckChange}
            checkedIds={checkedIds}
            rowAuth={rowAuth}
            rowAuthMsg={rowAuthMsg}
            disabledRowCount={this.state.disabledRowCount}
            disabledRowIds={this.state.disabledRowIds}
            onlyShowAuthenticated={onlyShowAuthenticated}
            toggleAuthenticatedPages={toggleAuthenticatedPages}
            rightOfTable={rightOfTable}
            builderListViewFeature={builderListViewFeature}
          />
        )}
      </div>
    );
  }
}
